import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);
const switchEndPoint = (panel) => {
  console.log(panel)
  if (panel == "crosssell") {
    return "crosssell";
  } else if (panel == "recent") {
    return "getsbwelcome";
  } else if (panel == "embedRecent") {
    return "getsbwelcome";
  }
  else if (panel == "sbaction") {
    return "sbaction";
  } else if (panel == "usergroup") {
    return "usergroup";
  } else {
    return "getsimilarproducts";
  }
};

const fetchProducts = ({ state, commit }, payload) => {
  const env = process.env.NODE_ENV == 'development' ? 'stag' : "app";
  let panel = payload.panel;
  let panelOpen = panel + "Open";
  let updateMutation = "UPDATE_" + payload.panel.toString().toUpperCase();
  let resetMutation = "RESET_" + payload.panel.toString().toUpperCase();
  let data = payload.data;
  let headers = payload.headers;
  let togglePanel = payload.toggle;
  let excludeHistory = payload && payload.excludeHistory ? payload.excludeHistory : false;;
  let force = payload && payload.force ? payload.force : false;
  let productId = data.productid;
  if (panel == 'similar') {
    if (excludeHistory == true) {
      data.excludeHistory = excludeHistory
    }
    console.log('excludeHistory', excludeHistory)
  }

  if (!state.isMobile || data.page <= 1) {
    commit("TOGGLE_LOADING", true);
  } else {
    state.nextLoaderMobile = true;
  }
  if (togglePanel) {
    // Open panel and show loading indicator
    commit("TOGGLE_PANEL", {
      name: panelOpen,
      force: true,
      toggle: togglePanel,
    });
  }
  if (payload.reset) {
    commit(`${resetMutation}`);
  }
  if (data) {
    //console.log(headers);
    if (productId && productId != state.lastProductId) {
      commit("UPDATE_PRODUCT_ID", data.productid);
    }
    axios
      .post(`https://${env}.shopbox.ai/stag/${switchEndPoint(panel)}`, data, {
        headers,
      })
      .then((response) => response.data)
      .then((payload) => {
        // if Payload gets returned remove loading and show products
        if (payload.brand) {
          commit("SET_BRAND", payload.brand);
        } else {
          commit("SET_BRAND", null);
        }
        commit("TOGGLE_LOADING", false);
        commit(`${updateMutation}`, payload.products);
        commit("RESIZE_PANEL", {
          length: payload.products.length,
          page: data.page,
        });
        commit("TOGGLE_INFINITE_LOAD", false);
        if (payload.products.length == 0 && state.isMobile && (state.recentOpen || state.similarOpen)) {
          console.log('then infinit')
          commit("TOGGLE_INFINITE_LOAD", true);

        }
      })
      .catch(() => {
        commit("TOGGLE_LOADING", false);
        commit("TOGGLE_INFINITE_LOAD", true);
        // commit(`${updateMutation}`, []);
      });
  }

  if (togglePanel && !force) {
    // Close panel if already opened

    commit("TOGGLE_PANEL", { name: panelOpen });
  }
};

const emitEvent = ({ state, commit }, payload) => {


  const env = process.env.NODE_ENV == 'development' ? 'stag' : "app";
  const url = `https://${env}.shopbox.ai/sendevent/${payload.type}`;
  const default_headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    clientID: state.site,
  };
  let headers = { ...default_headers, ...payload.headers };
  let data = payload.data || {};

  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  };

  if (state.stopInfiniteLoad == false) {
    fetch(url, options)
      .then((response) => response.text())
      .then((text) => {
        try {
          const payload = JSON.parse(text);
          if (payload) {
            if (payload.control_group != null) {
              commit("SET_CONTROL_GROUP", payload.control_group);
            }

          }
          // console.log("event emited", payload);
        } catch (e) {
          // console.log(err);
        }
      })
  }

};

const fetchPartnerCustomerId = ({ state }, payload) => {
  const env = process.env.NODE_ENV == 'development' ? 'stag' : "app";
  const default_headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    clientID: state.site,
  };
  let headers = { ...default_headers };
  let data = payload.data || {};
  axios
    .post(`https://${env}.shopbox.ai/stag/partnercid`, data, {
      headers,
    })
    .then((response) => response.data)
    .then((payload) => {
      if (payload && payload.existing_uuid) {
        console.log(`new user id ${payload.existing_uuid}`);
      }
      //    console.log("event emited", payload);
    });

};

const fetchPartnerDeviceId = ({ state }, payload) => {
  const env = process.env.NODE_ENV == 'development' ? 'stag' : "app";
  const default_headers = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    clientID: state.site,
  };
  let headers = { ...default_headers };
  let data = payload.data || {};
  axios
    .post(`https://${env}.shopbox.ai/stag/partnerdid`, data, {
      headers,
    })
    .then((response) => response.data)
    .then((payload) => {
      if (payload && payload.existing_uuid) {
        console.log(`new user id ${payload.existing_uuid}`);
      }
      //    console.log("event emited", payload);
    });

};

export default {
  emitEvent,
  fetchProducts,
  fetchPartnerCustomerId,
  fetchPartnerDeviceId
};
